import { render, staticRenderFns } from "./MultiHorizontalBar.vue?vue&type=template&id=48a35b2c&"
import script from "./MultiHorizontalBar.vue?vue&type=script&lang=ts&"
export * from "./MultiHorizontalBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports